import { Injectable, Injector } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MainComponent } from "../components/main-component/main.component";
@Injectable({
  providedIn: "root",
})
export class ErrorLoggingService extends MainComponent {
  error_logs = {};
  isSubmitted:boolean=true;
  constructor(public injector: Injector, public route: ActivatedRoute) {
    super(injector, route);
  }
  logErrors(error,errorType,stackTrace){
    if(errorType == 'front-end'){
      if(this.checkErrorBeforeSaving(stackTrace)){
        this.postErrorObjToDB(this.prePareFront_endErrorObj(errorType,stackTrace))
      }
    }else if(errorType == 'back-end'){
      this.postErrorObjToDB(this.prePareBack_endErrorObj(error,errorType,stackTrace))
    }
  }
  postErrorObjToDB(data){
    if(this.appService.getSessionId() && !this.storageService.getLocalStorageDataSync("auto_login")){
      //only allowing for loggedin user audit log
      this.baseService
      .action(data, "add", "account-management", 'audit_log', false).subscribe((res)=>{
        if(res){
         //TODO
        }
      },(err)=>{
      })
    }
     
  }
  checkErrorBeforeSaving(stackTrace){
    if(!this.appService.getSessionId() || this.appService._currentSessionData.encryptKey == undefined){
      return false
    }
      if(stackTrace && stackTrace.includes('NG0100')){
        return false
      }
        return true
  }
  getUserInfoBasedOnKeys(key){
    if(localStorage && localStorage.hasOwnProperty('currentUser')){
      let data = JSON.parse(localStorage.getItem('currentUser'));
      switch(key) {
        case "user_id":
            return data[key]?data[key]:'';
        case "login_id":
            return data[key]?data[key]:'';
        case "user_type":
            return data[key]?data[key]:'';
        case "first_name":
            return data[key]?data[key]:'';
        default:
          return ""
      }
    }
  }
  getOrganizationKeys(key){
    let org = this.appService.getOrganization();
    if(org){
      return org[key]?org[key]:'';
    }
  }
  prePareFront_endErrorObj(errorType,stackTrace){
    this.error_logs = {
    application: this.baseService.getAppName(),
    current_url: window.location.href,
    type: errorType,
    category: errorType,
    user_id: this.getUserInfoBasedOnKeys("user_id"),
    full_strack_trace: stackTrace, //Error strack track which will logged in error handling service
    g_creation_datetime: Date.now(), //
    meta_data: "", //( it will be an open object , In case of fronted , current data in localhost and anything else we can log, in case of backend class name etc)
    account_id: this.getOrganizationKeys('account_id'),
    facility_id: this.getOrganizationKeys('org_id'), // (if present)
    account_name: this.getUserInfoBasedOnKeys("first_name"),
    user_name: this.getUserInfoBasedOnKeys("first_name"),
    facility_name: this.getOrganizationKeys('org_name'),
    resource_name:localStorage.CurrentResource?localStorage.CurrentResource:'',
    resource_action:"MODIFY",
    resource_id:'id',
    current_data:sessionStorage.currentData?sessionStorage.currentData:'',
    is_front_end:true,
    currentTitle:this.baseService.setDefaultTitle(),
    current_role:localStorage.CURRENT_ROLE?JSON.parse(localStorage.CURRENT_ROLE):{}
  };
  return this.error_logs;
  }
  prePareBack_endErrorObj(error,errorType,stackTrace){
    this.error_logs = {
    application: this.baseService.getAppName(),
    current_url: window.location.href,
    category: errorType,
    user_id: this.getUserInfoBasedOnKeys("user_id"),
    g_creation_datetime: Date.now(), //
    meta_data: error.error, //( it will be an open object , In case of fronted , current data in localhost and anything else we can log, in case of backend class name etc)
    account_id: this.getOrganizationKeys('account_id'),
    facility_id: this.getOrganizationKeys('org_id'), // (if present)
    account_name: this.getUserInfoBasedOnKeys("first_name"),
    user_name: this.getUserInfoBasedOnKeys("first_name"),
    facility_name: this.getOrganizationKeys('org_name'),
    response_code: error.status, // back-end error code 
    response_data: error.message,
    resource_name:localStorage.CurrentResource?localStorage.CurrentResource:'',
    error_name:error.statusText,
    resource_type:localStorage.CurrentResource?localStorage.CurrentResource:'',
    response_message:error.statusText,
    error_url:error.url,
    current_data:sessionStorage.currentData?sessionStorage.currentData:'',
    is_front_end:true,
    errorType:error.name,
    resource_action:"LIST"
  };
  return this.error_logs;
  }
  
}
